(function () {
  var SECTION_SELECTOR = '.oddit-section-split-numbered-tabs';

  function initSection(section) {
    var tabs = section.querySelectorAll('.oddit-section-split-numbered-tabs__tab');
    var panels = section.querySelectorAll('.oddit-section-split-numbered-tabs__panel');
    if (!tabs.length || !panels.length) return;

    function activateTab(index) {
      for (var i = 0; i < tabs.length; i++) {
        var isActive = i === index;
        tabs[i].classList.toggle('oddit-section-split-numbered-tabs__tab--active', isActive);
        tabs[i].setAttribute('aria-selected', isActive ? 'true' : 'false');
        tabs[i].setAttribute('tabindex', isActive ? '0' : '-1');
      }
      for (var j = 0; j < panels.length; j++) {
        var panelActive = j === index;
        panels[j].classList.toggle('oddit-section-split-numbered-tabs__panel--active', panelActive);
        if (panelActive) {
          panels[j].removeAttribute('hidden');
        } else {
          panels[j].setAttribute('hidden', '');
        }
      }
    }

    function handleClick(e) {
      var btn = e.currentTarget;
      var index = Number(btn.getAttribute('data-tab-index'));
      if (isNaN(index)) return;
      activateTab(index);
    }

    function handleKeydown(e) {
      var key = e.key;
      var current = Number(e.currentTarget.getAttribute('data-tab-index'));
      if (isNaN(current)) return;

      var next = null;
      if (key === 'ArrowRight' || key === 'ArrowDown') {
        next = (current + 1) % tabs.length;
      } else if (key === 'ArrowLeft' || key === 'ArrowUp') {
        next = (current - 1 + tabs.length) % tabs.length;
      } else if (key === 'Home') {
        next = 0;
      } else if (key === 'End') {
        next = tabs.length - 1;
      }

      if (next !== null) {
        e.preventDefault();
        activateTab(next);
        tabs[next].focus();
      }
    }

    for (var k = 0; k < tabs.length; k++) {
      tabs[k].addEventListener('click', handleClick);
      tabs[k].addEventListener('keydown', handleKeydown);
    }
  }

  function init() {
    var sections = document.querySelectorAll(SECTION_SELECTOR);
    for (var i = 0; i < sections.length; i++) initSection(sections[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });
})();